export const CONTRACT_SEARCH = 'v1/contract/search?query=';
